import {useAuth0} from '@auth0/auth0-react';
import {asyncWithLDProvider, useLDClient} from 'launchdarkly-react-client-sdk';
import {Fragment, FunctionComponent, useEffect} from 'react';
import {getLdClientSideId} from '../utils/runtimeVars';
import * as Sentry from '@sentry/react';

const launchDarklyClientSideId = getLdClientSideId();

const LaunchDarklyProvider = async (): Promise<FunctionComponent<any>> => {
  if (launchDarklyEnabled()) {
    return (await asyncWithLDProvider({
      clientSideID: launchDarklyClientSideId!,
      context: {
        kind: 'user',
        key: 'anonymous@bioplan.ai',
        anonymous: true,
      },
      options: {
        inspectors: [Sentry.buildLaunchDarklyFlagUsedHandler()],
      },
    })) as FunctionComponent;
  } else {
    return Fragment;
  }
};

const launchDarklyEnabled = () => {
  return !!launchDarklyClientSideId;
};

const LaunchDarklyComponent = () => {
  const {isAuthenticated, user} = useAuth0();
  const client = useLDClient();

  client?.on('error', (e) => {
    /*do not throw client network error to sentry*/
  });

  useEffect(() => {
    if (isAuthenticated && user) {
      client?.identify({
        kind: 'user',
        key: user.sub,
        email: user.email,
        name: user.name,
        anonymous: false,
      });
    } else if (!isAuthenticated) {
      client?.identify({
        kind: 'user',
        key: 'anonymous@bioplan.ai',
        anonymous: true,
      });
    }
  }, [isAuthenticated, client]);

  return null;
};

const LaunchDarkly = {
  Provider: LaunchDarklyProvider,
  Component: LaunchDarklyComponent,
};

export default LaunchDarkly;
